// src/pages/Services.js
import React, { useState } from "react";
import "../index.css";

export default function Services() {
  const [activeAccordion, setActiveAccordion] = useState(null);

  // construit un mailto prérempli
  const buildMailto = (service) => {
    const to = "contact@hlbk.fr";
    const subject = `Demande de devis — ${service}`;
    const body = [
      `Bonjour Maxime,`,
      ``,
      `Je souhaite un devis pour : ${service}`,
      ``,
      `• Date/horaires :`,
      `• Lieu :`,
      `• Type / formule envisagée :`,
      `• Usage des images (perso/entreprise/web/print) :`,
      ``,
      `Mes coordonnées :`,
      `• Nom :`,
      `• Email :`,
      `• Téléphone :`,
      ``,
      `Merci !`,
      `— Envoyé depuis hlbk.fr`
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const ServiceCard = ({ img, title, desc, sections }) => (
    <article className="service-item service-elevated">
      <img className="svc-thumb" src={img} alt={title} />
      <h2 className="svc-title">{title}</h2>
      <p className="svc-blurb">{desc}</p>

      <div className="service-acc">
        {sections.map((section, idx) => {
          const id = `${title}-${idx}`;
          return (
            <details
              key={id}
              className="accordion"
              open={activeAccordion === id}
              onClick={(e) => {
                e.preventDefault();
                setActiveAccordion(activeAccordion === id ? null : id);
              }}
            >
              <summary>{section.label}</summary>
              <div className="accordion-content">{section.content}</div>
            </details>
          );
        })}
      </div>

      <div className="svc-cta-wrap">
        <a href={buildMailto(title)} className="btn-cta btn-cta-red">
          DEMANDER UN DEVIS
        </a>
      </div>
    </article>
  );

  return (
    <section className="services-page">
      <div className="services-grid">
        {/* Mariage */}
        <ServiceCard
          img="/images/services/mariage.jpg"
          title="Mariage"
          desc="Revivez l’émotion du jour J avec un reportage discret, vrai et lumineux."
          sections={[
            {
              label: "Formules",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Essentiel <span className="duration">— 4h</span></span>
                    <span className="price-chip">750€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Élégance <span className="duration">— 8h</span></span>
                    <span className="price-chip">1 150€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Prestige <span className="duration">— 12h</span></span>
                    <span className="price-chip">1 450€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & naturel</li>
                  <li>Galerie privée</li>
                  <li>Livraison pour web & print</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>Heure supplémentaire en sus</li>
                  <li>Séance engagement / Day after — <em>sur demande</em></li>
                  <li>Livre photo & tirage — <em>sur demande</em></li>
                </ul>
              ),
            },
          ]}
        />

        {/* Portrait */}
        <ServiceCard
          img="/images/services/portrait.jpg"
          title="Portrait"
          desc="Des portraits naturels et soignés — en extérieur ou en studio."
          sections={[
            {
              label: "Formules",
              content: (
                <ul className="svc-list centered">
                  {/* Extérieur */}
                  <li className="muted" style={{ textAlign: "center", borderBottom: 0, marginTop: 2 }}>
                    Extérieur
                  </li>
                  <li>
                    <span className="svc-line">Découverte <span className="duration">— 30 min</span></span>
                    <span className="price-chip">150€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Émotion <span className="duration">— 1h</span></span>
                    <span className="price-chip">220€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Signature <span className="duration">— 2h</span></span>
                    <span className="price-chip">350€ TTC</span>
                  </li>

                  {/* Studio (sans “fonds / tenues”) */}
                  <li className="muted" style={{ textAlign: "center", borderBottom: 0, marginTop: 10 }}>
                    Studio
                  </li>
                  <li>
                    <span className="svc-line">Essentiel <span className="duration">— 45 min</span></span>
                    <span className="price-chip">190€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Créative <span className="duration">— 2h</span></span>
                    <span className="price-chip">350€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Prestige <span className="duration">— 4h</span></span>
                    <span className="price-chip">550€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Aucune limite de photos</li>
                  <li>Galerie privée</li>
                  <li>Conseils tenues & lieux</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>Tirages — <em>sur demande</em></li>
                  <li>Album photo — <em>sur demande</em></li>
                  <li>Déplacement hors Nancy en sus</li>
                </ul>
              ),
            },
          ]}
        />

        {/* Événement */}
        <ServiceCard
          img="/images/services/evenement.jpg"
          title="Événement"
          desc="Anniversaires, baptêmes, soirées privées ou associatives — des images vivantes et sincères."
          sections={[
            {
              label: "Formules",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Mini <span className="duration">— 2h</span></span>
                    <span className="price-chip">300€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Standard <span className="duration">— 4h</span></span>
                    <span className="price-chip">550€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Deluxe <span className="duration">— 8h</span></span>
                    <span className="price-chip">980€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & réactif</li>
                  <li>Galerie privée incluse</li>
                  <li>Livraison HD sécurisée</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>Heure supplémentaire en sus</li>
                  <li>Tirages / album — <em>sur demande</em></li>
                </ul>
              ),
            },
          ]}
        />

        {/* Entreprise */}
        <ServiceCard
          img="/images/services/entreprise.jpg"
          title="Entreprise"
          desc="Portraits d’équipe, reportage, valorisation d’espaces & événements pro."
          sections={[
            {
              label: "Formules",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Demi-journée <span className="duration">— 4h</span></span>
                    <span className="price-chip">490€ HT</span>
                  </li>
                  <li>
                    <span className="svc-line">Journée complète <span className="duration">— 8h</span></span>
                    <span className="price-chip">950€ HT</span>
                  </li>
                  <li>
                    <span className="svc-line">Deluxe <span className="duration">— 2 jours</span></span>
                    <span className="price-chip">1 800€ HT</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Images adaptées web & print</li>
                  <li>Galerie sécurisée</li>
                  <li>Couverture grands événements</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>Portraits supplémentaires <em>sur demande</em></li>
                  <li>Déplacement inclu jusqu'à 30km autour de Tomblaine</li>
                  <li>Retouches avancées — <em>sur demande</em></li>
                </ul>
              ),
            },
          ]}
        />
      </div>
    </section>
  );
}